

export const lungueges = {
    en: 'English',
    hi: 'Hindi',
    gu: 'Gujarati',
    kn: 'Kannada',
    te: 'Telugu',
    ta: 'Tamil',
    ko: 'Korean',
    es: 'Spanish',
    zh: 'Chinese',
    ar: 'Arabic',
    bn: 'Bengali',
    ms: 'Malay',
    ml: 'Malayalam',
    mr: 'Marathi',
    ru: 'Russian',
    id: 'Indonesian',
};